import React from 'react';
import SlideBanner from '@components/common/SlideBanner/SlideBanner';
import ShareholderNav from '@components/Shareholder/ShareholderNav';
import ShareholderDetailsHome from '@components/Shareholder/ShareholderDetailsHome';
import {NextSeo} from 'next-seo';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';
export default function ShareholderDetail(props) {
    const {locale} = useRouter();
    const {seoPage, categories, shareholderNews, shareholderContact, id} = props;
    return (
        <>
            {seoPage && <NextSeo {...seoPage} />}
            <SlideBanner
                titleBanner={getLocaleContent(locale, 'page.shareholder-relations.title')}
                image="/bw_image/medial-facility.png"
            />
            <ShareholderNav />
            <ShareholderDetailsHome
                id={id}
                categories={categories}
                shareholderNews={shareholderNews}
                shareholderContact={shareholderContact}
            />
        </>
    );
}

ShareholderDetail.PageName = 'SHARE-HOLDER-DETAILS';
